import { Fragment, ReactElement, useMemo } from 'react';
import { DeathCancellationNotificationsResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { DeathCancellationNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { DeathCancellationNotificationsResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { DeathCancellationNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { DeathCancellationNotificationsResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import CancellationDeathNotificationShared from 'shell/components/shared/research-notifications/research-death/detail';

interface CancellationDeathNotificationCivilStatusSharedProps {
  scope?: string;
}

const CancellationDeathNotificationCivilStatusShared = ({
  scope,
}: CancellationDeathNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return DeathCancellationNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return DeathCancellationNotificationsResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return DeathCancellationNotificationsResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return DeathCancellationNotificationsResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return DeathCancellationNotificationsResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <CancellationDeathNotificationShared
        goBackUrl={goBackUrl}
        items={items}
        goBackUrlDetail={goBackUrlDetail}
      />
    </Fragment>
  );
};

CancellationDeathNotificationCivilStatusShared.displayName =
  'Cancellation Death Notification Page component';

export default CancellationDeathNotificationCivilStatusShared;
